import React, { useEffect, useRef } from 'react';

import {
  CheckCircleTwoTone,
  CloseCircleTwoTone,
  EditTwoTone,
  DeleteTwoTone,
} from '@ant-design/icons';
import { Space, Tooltip } from 'antd';

import useManager from '../../../hooks/manager';
import Table from '../../Table';
import ColumnSearch from '../../Table/Filter';
import { Action } from '../../Table/styles';
import UpdateForm from '../UpdateForm';

function CompanyTable() {
  const updateRef = useRef();
  const {
    loading, datas, load, destroy,
  } = useManager();

  useEffect(() => {
    load('/Company');
  }, [load]);

  const columns = [
    {
      title: 'CNPJ',
      dataIndex: 'cnpj',
      key: 'cnpj',
      sorter: (a, b) => a.cnpj.localeCompare(b.cnpj),
      sortDirections: ['descend', 'ascend'],
      ellipsis: true,
      filterMultiple: false,
      ...ColumnSearch('CNPJ', 'cnpj'),
    },
    {
      title: 'CPF',
      dataIndex: 'cpf',
      key: 'cpf',
      sorter: (a, b) => a.cpf.localeCompare(b.cpf),
      sortDirections: ['descend', 'ascend'],
      filterMultiple: false,
      ellipsis: true,
      width: 120,
      ...ColumnSearch('CPF', 'cpf'),
    },
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
      sortDirections: ['descend', 'ascend'],
      ellipsis: true,
      filterMultiple: false,
      ...ColumnSearch('Nome', 'name'),
    },
    {
      title: 'Fantasia',
      dataIndex: 'fantasyName',
      key: 'fantasyName',
      sorter: (a, b) => a.fantasyName.localeCompare(b.fantasyName),
      sortDirections: ['descend', 'ascend'],
      ellipsis: true,
      filterMultiple: false,
      ...ColumnSearch('Fantasia', 'fantasyName'),
    },
    {
      title: 'Ativo',
      dataIndex: 'active',
      key: 'active',
      width: 96,
      align: 'center',
      render: (text, record) => (record.active ? (
        <Tooltip placement="top" title="Cadastro Ativo">
          <CheckCircleTwoTone twoToneColor="#389e0d" />
        </Tooltip>
      ) : (
        <Tooltip placement="top" title="Cadastro Inativo">
          <CloseCircleTwoTone twoToneColor="#f5222d" />
        </Tooltip>
      )),
    },
  ];

  return (
    <>
      <UpdateForm ref={updateRef} />
      <Table
        data={datas}
        loading={loading}
        columns={columns}
        actions={{
          title: 'Ações',
          key: 'action',
          width: 100,
          align: 'center',
          render: (text, record) => (
            <Space size="middle">
              <Tooltip placement="top" title="Alterar">
                <Action onClick={() => updateRef.current.open(record.id || record._id)}>
                  <EditTwoTone />
                </Action>
              </Tooltip>
              <Tooltip placement="top" title="Excluir">
                <Action onClick={() => destroy(record.id || record._id, '/company')}>
                  <DeleteTwoTone twoToneColor="#f00" />
                </Action>
              </Tooltip>
            </Space>
          ),
        }}
      />
    </>
  );
}

export default CompanyTable;
